import { DEBUGGING, LEGACY_PATH_PREFIX, LEGACY_LOCAL_PORT, PAGE_LINK_SUPPORT } from '../constants';

const openTab = (url) => {
  window.open(url, '_blank');
};

const parseLegacyRoute = (path) => {
  if (DEBUGGING) {
    return `http://local.popinnow.com${LEGACY_LOCAL_PORT}${LEGACY_PATH_PREFIX}${path}`;
  } else {
    const domain = window.location.hostname.split('.')[0];
    return `https://${domain}.popinnow.com${LEGACY_PATH_PREFIX}${path}`;
  }
};

// const parseRoute = (path) => {
//   if (DEBUGGING) {
//     return `http://local.popinnow.com:3000${GLOBAL_PATH_PREFIX}${path}`;
//   } else {
//     const domain = window.location.hostname.split('.')[0];
//     return `https://${domain}.popinnow.com${GLOBAL_PATH_PREFIX}${path}`;
//   }
// };

export const NavigationUtils = {

  createLegacyRoute (path) {
    return parseLegacyRoute(path);
  },

  openTab (url) {
    openTab(url);
  },

  routeToLegacy (path) {
    const url = parseLegacyRoute(path);
    window.location.assign(url);
  },

  backToPopin (force) {
    if (window.location.pathname !== '/r/dashboard' || force) {
      this.routeToLegacy('/dashboard');
      return true;
    } else {
      return false;
    }
  },

  routeToSupport () {
    openTab(PAGE_LINK_SUPPORT);
  },

  unauthorizedAccess () {
    this.routeToLegacy(`/signin?path=${encodeURIComponent(window.location.pathname.substring(1))}`);
  }
};
